import { EntityId } from "@reduxjs/toolkit";
import axios from "axios";
export interface FeaturedLink {
  id: EntityId;
  iconSrc: string;
  name: string;
  href: string;
  text: string;
  external: boolean;
  showOnHome: boolean;
}

export const featuredLinks: FeaturedLink[] = [
  {
    id: 1,
    iconSrc: "/assets/images/github.svg",
    name: "Github",
    href: "https://github.com/cs-clarence",
    text: "open github repository",
    external: true,
    showOnHome: true,
  },
  {
    id: 2,
    href: "mailto:rencedm112@gmail.com",
    iconSrc: "/assets/images/email.svg",
    name: "Email Address",
    text: "send an email",
    external: true,
    showOnHome: false,
  },
  {
    id: 3,
    href: "https://www.linkedin.com/in/rencedm112",
    iconSrc: "/assets/images/linkedin.svg",
    name: "LinkedIn",
    text: "open linkedin profile",
    external: true,
    showOnHome: false,
  },
];

export interface ToolCategory {
  id: EntityId;
  name: string;
}
export interface Tool {
  id: EntityId;
  name: string;
}

export interface ToolCategoryRelation {
  id: EntityId;
  toolID: EntityId;
  categoryID: EntityId;
}

export const toolCategories: ToolCategory[] = [
  { id: 1, name: "Front-End" },
  { id: 2, name: "Back-End" },
  { id: 3, name: "Languages" },
  { id: 4, name: "Design" },
];

export const tools: Tool[] = [
  { id: 1, name: "JavaScript" },
  { id: 2, name: "TypeScript" },
  { id: 3, name: "HTML" },
  { id: 4, name: "CSS" },
  { id: 5, name: "SASS/SCSS" },
  { id: 6, name: "SQL" },
  { id: 7, name: "Rust" },
  { id: 8, name: "C/C++" },
  { id: 9, name: "Java" },
  { id: 10, name: "Kotlin" },
  { id: 11, name: "NodeJS" },
  { id: 12, name: "ExpressJS" },
  { id: 13, name: "EJS" },
  { id: 14, name: "MongoDB" },
  { id: 15, name: "Mongoose" },
  { id: 16, name: "PostgreSQL" },
  { id: 17, name: "ReactJS" },
  { id: 18, name: "React Router" },
  { id: 19, name: "Redux" },
  { id: 20, name: "VueJS" },
  { id: 21, name: "Vue Router" },
  { id: 22, name: "Vuex" },
  { id: 23, name: "Figma" },
  { id: 24, name: "Adobe XD" },
  { id: 25, name: "Photoshop" },
  { id: 26, name: "Illustrator" },
  { id: 27, name: "InDesign" },
];

export const toolCategoryRelations: ToolCategoryRelation[] = [
  { id: 1, toolID: 1, categoryID: 3 },
  { id: 2, toolID: 2, categoryID: 3 },
  { id: 3, toolID: 3, categoryID: 3 },
  { id: 4, toolID: 4, categoryID: 3 },
  { id: 5, toolID: 5, categoryID: 3 },
  { id: 6, toolID: 6, categoryID: 3 },
  { id: 7, toolID: 7, categoryID: 3 },
  { id: 8, toolID: 8, categoryID: 3 },
  { id: 9, toolID: 9, categoryID: 3 },
  { id: 10, toolID: 10, categoryID: 3 },
  { id: 11, toolID: 11, categoryID: 2 },
  { id: 12, toolID: 12, categoryID: 2 },
  { id: 13, toolID: 13, categoryID: 2 },
  { id: 14, toolID: 14, categoryID: 2 },
  { id: 15, toolID: 15, categoryID: 2 },
  { id: 16, toolID: 16, categoryID: 2 },
  { id: 17, toolID: 17, categoryID: 1 },
  { id: 18, toolID: 18, categoryID: 1 },
  { id: 19, toolID: 19, categoryID: 1 },
  { id: 20, toolID: 20, categoryID: 1 },
  { id: 21, toolID: 21, categoryID: 1 },
  { id: 22, toolID: 22, categoryID: 1 },
  { id: 23, toolID: 23, categoryID: 4 },
  { id: 24, toolID: 24, categoryID: 4 },
  { id: 25, toolID: 25, categoryID: 4 },
  { id: 26, toolID: 26, categoryID: 4 },
  { id: 27, toolID: 27, categoryID: 4 },
];
export interface AuthorInfo {
  id: EntityId;
  name: string;
  title: string;
  displayPic: string;
  aboutDesc: string;
  resumeHref: string;
}

export const authorInfo: AuthorInfo = {
  id: 1,
  name: "Clarence Manuel",
  title: "Full-Stack Web Developer",
  displayPic: "https://i.ibb.co/y6G2Lxg/dp.jpg",
  resumeHref:
    "https://drive.google.com/file/d/1Ba2h7yxju_LSVv7kW-2OO-Xbe95BTIJD/view?usp=sharing",
  aboutDesc: `Fullstack Web-Developer currently based from the Philippines.

I have experience in using various Front-End and Back-End technologies
such as Vue, React, Node, and ExpressJS.

I am always eager to learn about the newest technologies in the
software industry.`,
};

export interface AuthorData {
  featuredLinks: FeaturedLink[];
  tools: Tool[];
  toolCategories: ToolCategory[];
  toolCategoryRelations: ToolCategoryRelation[];
  authorInfo?: AuthorInfo;
}

export const authorProfileAPI = {
  async fetchData() {
    const data: AuthorData = {
      featuredLinks: (
        await axios.get<FeaturedLink[]>(
          `${
            process.env.REACT_APP_BACKEND_URL ?? ""
          }/author-profile/featured-links`
        )
      ).data,
      tools: (
        await axios.get<Tool[]>(
          `${process.env.REACT_APP_BACKEND_URL ?? ""}/author-profile/tools`
        )
      ).data,
      toolCategories: (
        await axios.get<ToolCategory[]>(
          `${
            process.env.REACT_APP_BACKEND_URL ?? ""
          }/author-profile/tool-categories`
        )
      ).data,
      toolCategoryRelations: (
        await axios.get<ToolCategoryRelation[]>(
          `${
            process.env.REACT_APP_BACKEND_URL ?? ""
          }/author-profile/tool-category-relations`
        )
      ).data,
      authorInfo: (
        await axios.get<AuthorInfo>(
          `${process.env.REACT_APP_BACKEND_URL ?? ""}/author-profile`
        )
      ).data,
    };
    // console.log(data);
    return data;
  },

  async fetchFeaturedLinks() {
    return (
      await axios.get<FeaturedLink[]>(
        `${
          process.env.REACT_APP_BACKEND_URL ?? ""
        }/author-profile/featured-links`
      )
    ).data;
  },

  async fetchAuthorInfo() {
    return (
      await axios.get<AuthorInfo>(
        `${process.env.REACT_APP_BACKEND_URL ?? ""}/author-profile`
      )
    ).data;
  },

  async fetchTools() {
    return (
      await axios.get<Tool[]>(
        `${process.env.REACT_APP_BACKEND_URL ?? ""}/author-profile/tools`
      )
    ).data;
  },

  async fetchToolCategories() {
    return (
      await axios.get<ToolCategory[]>(
        `${
          process.env.REACT_APP_BACKEND_URL ?? ""
        }/author-profile/tool-categories`
      )
    ).data;
  },

  async fetchToolCategoryrRelations() {
    return (
      await axios.get<ToolCategoryRelation[]>(
        `${
          process.env.REACT_APP_BACKEND_URL ?? ""
        }/author-profile/tool-category-relations`
      )
    ).data;
  },

  async updateAuthorInfo(author: AuthorInfo) {
    await axios.put<AuthorInfo>(
      `${process.env.REACT_APP_BACKEND_URL ?? ""}/author-profile/${author.id}`,
      author,
      { withCredentials: true }
    );
  },

  async deleteFeaturedLink(id: EntityId) {
    await axios.delete<FeaturedLink>(
      `${
        process.env.REACT_APP_BACKEND_URL ?? ""
      }/author-profile/featured-links/${id}`,
      { withCredentials: true }
    );
  },

  async postFeaturedLink(fl: Omit<FeaturedLink, "id">) {
    await axios.post<FeaturedLink>(
      `${
        process.env.REACT_APP_BACKEND_URL ?? ""
      }/author-profile/featured-links`,
      fl,
      { withCredentials: true }
    );
  },

  async updateFeaturedLink(fl: FeaturedLink) {
    await axios.put<FeaturedLink>(
      `${
        process.env.REACT_APP_BACKEND_URL ?? ""
      }/author-profile/featured-links/${fl.id}`,
      fl,
      { withCredentials: true }
    );
  },
};
export default authorProfileAPI;
